import React from "react";
import { PageShell, SectionLabel, SlideCorner } from "@/components/Layout";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const DISCIPLINES = [
  ["Music", "labels · publishing · sync · catalogue"],
  ["Visual Art", "galleries · auctions · ip"],
  ["Dance", "festivals · companies · choreography commissions"],
  ["Theatre", "festivals · adaptations · ip"],
  ["Writing", "agents · imprints · adaptation rights"],
  ["Film", "festivals · distribution · sales agents"],
];

export default function Management() {
  return (
    <PageShell>
      <section className="relative grid-bg border-b border-border">
        <SlideCorner right="THE MANAGER" />
        <div className="max-w-[1600px] mx-auto px-5 md:px-10 pt-20 pb-16">
          <SectionLabel>The Manager · Artist representation across disciplines</SectionLabel>
          <h1 className="font-display text-5xl md:text-7xl lg:text-[7rem] font-bold leading-[0.9] tracking-tighter">
            One team. <br /> <span className="hl-coral">Your career.</span>
          </h1>
          <p className="mt-10 max-w-3xl text-white/80 text-base md:text-lg leading-relaxed">
            Music, visual art, dance, theatre, writing, film — managed under one roof. We do the deals, the deliverables, the difficult emails. You make the work. The contract is fair, the splits are clear, and the catalogue stays yours.
          </p>
        </div>
      </section>

      <section className="border-b border-border">
        <div className="max-w-[1600px] mx-auto px-5 md:px-10 py-20 grid md:grid-cols-3 gap-px bg-border">
          <Stat n="One desk" l="Deals · bookings · briefs" />
          <Stat n="Your IP" l="You own what you make" />
          <Stat n="Fair splits" l="Clear, written, signed" />
        </div>
      </section>

      <section className="border-b border-border">
        <div className="max-w-[1600px] mx-auto px-5 md:px-10 py-20">
          <SectionLabel>Verticals</SectionLabel>
          <h2 className="font-display text-4xl md:text-6xl font-bold leading-tight mb-12">
            One <span className="hl-cyan">roster.</span> Every <span className="hl-coral">discipline.</span>
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-border">
            {DISCIPLINES.map(([d, x], i) => (
              <div key={d} className="bg-background p-8 min-h-[200px]">
                <p className="meta-mono mb-4">— V{String(i + 1).padStart(2, "0")}</p>
                <p className="font-display text-3xl md:text-4xl font-bold">{d}</p>
                <p className="meta-mono mt-3 !text-white/70">{x}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section>
        <div className="max-w-[1200px] mx-auto px-5 md:px-10 py-24 text-center">
          <p className="font-serif-italic text-2xl md:text-4xl text-white/85 leading-snug">
            "You should be making the work. We'll do the deals, the deliverables, the difficult emails — and we'll do them better than anyone else in this country."
          </p>
          <Link to="/artizen-pass" className="btn-pill btn-coral inline-flex mt-10">Apply via the House tier <ArrowRight size={14} /></Link>
        </div>
      </section>
    </PageShell>
  );
}
function Stat({ n, l }) {
  return (
    <div className="bg-background p-8 md:p-12">
      <p className="num-display text-5xl md:text-7xl font-bold text-primary leading-none">{n}</p>
      <p className="meta-mono mt-4">{l}</p>
    </div>
  );
}
